import React from 'react';

export function useEffectOnce (effect: React.EffectCallback) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(effect, []);
}